export const VERSION = '5.4.18'
export const ACTIONS = {
    UPDATE: 'UPDATE',
    FORCE_UPDATE: 'FORCE_UPDATE',
    LOAD_JSON: 'LOAD_JSON',
    START_OVER: 'START_OVER',
    HISTORY: 'HISTORY',
    //ZALESSKU: 'ZALESSKU',
  };
export const DEFAULT_STATE_VALUE = '0'
export const ENGRAVING_TIMEOUT = 1000
export const INITIAL_STATE = {
  'version':VERSION,
  'showSticky':true,
  'active_view':1,
  'active_view4':1,
  'active_view5':1,
}
const STANDARD_DEFAULT = {
  //'ds':'HRD',
  'dctw':'1',
  /* 'cec':'WT', */
  'cross1':0,
  'cross2':0,
  'cross3':0,
  'rs2':'0',
  'bl2':'0'
}

export const DEFAULT_ATTR_VALUE = {
  'R1':{
    'ds':'HOV',
    //'dctw':'1',
    //'cec':'WT',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'WT',
    'hmet':'S',
    'rmet':'S',
    'bl':'0',
    ...STANDARD_DEFAULT},
    
  'R2':{
    'ds':'HECU',
    //'dctw':'1',
    //'cec':'PZ',
    'cec2':'0',
    'headc':'0',
    'rsetc':'WT',
    'hmet':'S',
    'rmet':'S',
    'bl':'0',
    ...STANDARD_DEFAULT},
    
  'R3':{
    'ds':'HECU',
    //'dctw':'1',
    'cec':'LBT',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'WT',
    'hmet':'S',
    'rmet':'S',
    'bl':'0',
    ...STANDARD_DEFAULT},
    
  'R4':{
    'ds':'HRD',
    //'dctw':'1',
    //'cec':'AM',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'WT',
    'hmet':'S',
    'rmet':'S',
    'bl':'0',
    ...STANDARD_DEFAULT},
    
  'R5':{
    'ds':'HOV',
    //'dctw':'1',
    //'cec':'PT',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'WT',
    'hmet':'S',
    'rmet':'S',
    'bl':'0',
    ...STANDARD_DEFAULT},
    
  'R6':{
    'ds':'HECU',
    //'dctw':'1',
    //'cec':'MG',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'WT',
    'hmet':'S',
    'rmet':'S',
    'bl':'0',
    ...STANDARD_DEFAULT},
    
  'R7':{
    'ds':'HOV',
    //'dctw':'1',
    //'cec':'TZ',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'S',
    'rmet':'S',
    'bl':'0',
    ...STANDARD_DEFAULT},
    
  'R8':{
    'ds':'HCU',
    //'dctw':'1',
    //'cec':'LBT',
    'cec2':'0',
    'headc':'0',
    'rsetc':'0',
    'hmet':'S',
    'rmet':'S',
    'bl':'0',
    ...STANDARD_DEFAULT},
    
  'R9':{
    'ds':'HCU',
    //'dctw':'1',
    //'cec':'CT', 
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'S',
    'rmet':'S',
    'bl':'0',
    ...STANDARD_DEFAULT},
    
  'R10':{
    'ds':'HRD',
    //'dctw':'1',
    //'cec':'AM',
    'cec2':'0',
    'headc':'0',
    'rsetc':'WT',
    'hmet':'S',
    'rmet':'S',
    'bl':'0',
    ...STANDARD_DEFAULT},
    
  'R11':{
    'ds':'HECU',
    //'dctw':'1',
    //'cec':'AM',
    'cec2':'0',
    'headc':'0',
    'rsetc':'WT',
    'hmet':'S',
    'rmet':'S',
    'bl':'0',
    ...STANDARD_DEFAULT},
    'R12':{
      'ds':'HECU',
      //'dctw':'1',
      //'cec':'AM',
      'cec2':'0',
      'headc':'WT',
      'rsetc':'WT',
      'hmet':'S',
      'rmet':'S',
      'bl':'0',
      ...STANDARD_DEFAULT}, 
  'P1':{
    'ds':'HPS',
    //'dctw':'1',
    'cec':'0',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'bl':'0',
    ...STANDARD_DEFAULT},
    
  'P2':{
    'ds':'HOV',
    //'dctw':'1',
    //'cec':'PT',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'bl':'0',
    ...STANDARD_DEFAULT},
  
  'P3':{
    'ds':'HOV',
    //'dctw':'1',
    //'cec':'LBT',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'bl':'0',
    ...STANDARD_DEFAULT},
  
  'P4':{
    'ds':'HCU',
    //'dctw':'1',
    //'cec':'AQ',
    'cec2':'0',
    'headc':'0',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'bl':'0',
    ...STANDARD_DEFAULT},
  
  'P5':{
    'ds':'HECU',
    //'dctw':'1',
    //'cec':'AM',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'WT',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'bl':'0',
    ...STANDARD_DEFAULT},
  
  'P6':{
    'ds':'HCU',
    //'dctw':'1',
    //'cec':'WT',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'bl':'0',
    ...STANDARD_DEFAULT},
  
  'P7':{
    'ds':'HRD',
    //'dctw':'1',
    //'cec':'TZ',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'bl':'0',
    ...STANDARD_DEFAULT},
  
  'P8':{
    'ds':'HRD',
    //'dctw':'1',
    //'cec':'TZ',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'WT',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'bl':'0',
    ...STANDARD_DEFAULT},
    'P9':{
      'ds':'HRD',
      //'dctw':'1',
      //'cec':'TZ',
      'cec2':'0',
      'headc':'WT',
      'rsetc':'WT',
      'hmet':'0',
      'rmet':'S',
      'rs':'0',
      'bl':'0',
      ...STANDARD_DEFAULT},
  'E1':{
    'ds':'HCU',
    //'dctw':'1',
    'cec':'WT',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'bl':'0',
    ...STANDARD_DEFAULT},
    
  'E2':{
    'ds':'HECU',
    //'dctw':'1',
    //'cec':'LBT',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'WT',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'bl':'0',
    ...STANDARD_DEFAULT},
    
  'E3':{
    'ds':'HRD',
    //'dctw':'1',
    //'cec':'MG',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'bl':'0',
    ...STANDARD_DEFAULT},
    
  'E4':{
    'ds':'HRD',
    //'dctw':'1',
    //'cec':'LBT',
    'cec2':'0',
    'headc':'0',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'bl':'0',
    ...STANDARD_DEFAULT},
    
  'E5':{
    'ds':'HRD',
    //'dctw':'1',
    //'cec':'AM',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'bl':'0',
    ...STANDARD_DEFAULT},
    
  'E6':{
    'ds':'HPS',
    //'dctw':'1',
    //'cec':'PT',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'bl':'0',
    ...STANDARD_DEFAULT},
    
  'E7':{
    'ds':'HCU',
    //'dctw':'1',
    //'cec':'TZ',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'bl':'0',
    ...STANDARD_DEFAULT},
    
  'E8':{
    'ds':'HPS',
    //'dctw':'1',
    //'cec':'PZ',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'bl':'0',
    ...STANDARD_DEFAULT},
  
  'B1':{
    'ds':'HOV',
    //'dctw':'1',
    'cec':'PZ',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    ...STANDARD_DEFAULT},

  'B2':{
    'ds':'HRD',
    //'dctw':'1',
    //'cec':'LBT',
    'cec2':'WT',
    'headc':'0',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    ...STANDARD_DEFAULT},

  'B3':{
    'ds':'HCU',
    //'dctw':'1',
    //'cec':'AM',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'bl':'0',
    'rs':'0',
    ...STANDARD_DEFAULT},

  'B4':{
    'ds':'HOV',
    //'dctw':'1',
    //'cec':'LBT',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    ...STANDARD_DEFAULT},

  'C1':{
    'initial':'',
    'type':'R',
    'sh':'R3',
    'ds':'HOV',
    'dctw':'1',
    'cec':'LBT',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'WT',
    'hmet':'S',
    'rmet':'S',
    'rs':'0',
    'rs2':'0',
    'bl':'0',
    'bl2':'0',
    'cross1':0,
    'cross2':0,
    'cross3':0},

  'C3':{
    'initial':'',
    'type':'E',
    'sh':'E1',
    'ds':'HCU',
    'dctw':'1',
    'cec':'WT',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'rs2':'0',
    'bl':'0',
    'bl2':'0',
    'cross1':0,
    'cross2':0,
    'cross3':0},

  'C2':{
    'initial':'',
    'type':'P',
    'sh':'P1',
    'ds':'HPS',
    'dctw':'1',
    'cec':'LBT',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'rs2':'0',
    'bl':'0',
    'bl2':'0',
    'cross1':0,
    'cross2':0,
    'cross3':0},

  'C4':{
    'initial':'',
    'type':'B',
    'sh':'B1',
    'ds':'HOV',
    'dctw':'1',
    'cec':'PZ',
    'cec2':'0',
    'headc':'WT',
    'rsetc':'0',
    'hmet':'0',
    'rmet':'S',
    'rs':'0',
    'rs2':'0',
    'bl':'0',
    'bl2':'0',
    'cross1':0,
    'cross2':0,
    'cross3':0}
}

export const SPECIAL_NOTE_SMALL = ''
//export const SPECIAL_NOTE_SMALL = 'Order by Sunday, February 1, 2026 for Valentine\'s Day delivery. This delivery date overrides regular processing times.'
//export const SPECIAL_NOTE_SMALL = "Order by Thursday, April 24, 2025 for Mother's Day delivery. This delivery date overrides regular processing times."
//export const SPECIAL_NOTE_SMALL = 'Order by Thursday, December 11, 2025 for Christmas delivery. ' //This delivery date overrides regular processing times. '

export const SPECIAL_NOTE_SMALL2 = ''
//export const SPECIAL_NOTE_SMALL2 = 'This delivery date overrides regular processing times. '
//export const SPECIAL_NOTE_SMALL1 = 'Need a gift by Christmas,  '
//export const SPECIAL_NOTE_LINK =  "//www.kay.com/-lastmingifts/c/9000001002?q=*%3Afeatures%3AjewelrySearchType_string%3ARing%3AringStyle_string%3AEngagement+Ring%3AringStyle_string%3ABridal+Set%3AringStyle_string%3AWedding&text=&searchStore=&loadMore=4"
//export const SPECIAL_NOTE_SMALL2 = ' to see engagement rings available for Christmas Delivery.'
export const SPECIAL_NOTE_BIG =  SPECIAL_NOTE_SMALL
//export const SPECIAL_NOTE_BIG = "Order by Thursday, April 14, 2022 for Mother's Day delivery. "
//export const SPECIAL_NOTE_BIG = 'Order by Monday, April 12, 2021 for Mother\'s Day delivery. This delivery date overrides regular processing times noted below.'
//export const SPECIAL_NOTE_BIG = 'Order by Tuesday, December 6, 2022 for Christmas delivery. This delivery date overrides regular processing times. '
export const MSG_NO_SESSION1 = 'Site error. Please return to '
export const MSG_NO_SESSION2 = ', personalize, and add to cart again. If problem persists, please contact customer service. We’re sorry for the inconvenience.'
export const MSG_NOT_READY_ADD_TO_CART = 'Please select RING SIZE in order to add product to the shopping bag'
export const MSG_NOT_READY_ADD_TO_CART1 = 'Please select '
export const MSG_NOT_READY_ADD_TO_CART2 = ' in order to add product to the shopping bag.'
export const MSG_NO_USER_DIAMOND ='Please provide all correct information for Customer Diamond'
export const PRICE_URL = 'https://test.thepersonalizedbest.com/fashion_getprice/'
export const PRICE_URL_PROD = '//main.thepersonalizedbest.com/fashion_getprice/'//'//main.thepersonalizedbest.com/fashion_getprice6/'
export const CFG_URL = '//test.thepersonalizedbest.com/fashion_cfg2sku6/'
export const CFG_URL_PROD = '//main.thepersonalizedbest.com/fashion_cfg2sku6/'//'//main.thepersonalizedbest.com/fashion_cfg2sku6/'
export const ADD_TO_CART_URL = 'https://test.thepersonalizedbest.com/fashion_add_to_cart1'
export const ADD_TO_CART_URL_PROD = 'https://main.thepersonalizedbest.com/fashion_add_to_cart1'//'https://thepersonalizedbest.com/fashion_add_to_cart1'
export const OPTION_URL = '//static.thepersonalizedbest.com/gfr/'
//export const DYNAMIC_OPTION_URL = '//bridalimages.thepersonalizedbest.com/bridal_getmimg/'
//export const DYNAMIC_OPTION_URL = '//test.thepersonalizedbest.com/bridal_getmimgFJC/'
export const DYNAMIC_OPTION_URL = '//bridalimages.thepersonalizedbest.com/bridal_getmimgFJC/'
export const DEFAULT_CFG = 'CFG12559000000000'
export const DEFAULT_K_SKU = '4BM8IYHT6' //'4BM8IYHFV'
export const DEFAULT_J_SKU = '4BKETEU4G'
//export const DEFAULT_K_SKU = '4C4U82MZ'
//export const DEFAULT_J_SKU = '46OFWA'

export const DEFAULT_Z_SKU = '4BP18I4KV'
export const DEFAULT_KO_SKU = '4BSUW3QBL' //'4IRADA4F' 

export const DEFAULT_K_SKU2 = '4BM8IYHT6' // '4BM8IYHFV'
export const DEFAULT_J_SKU2 = '4BKETEU4G' // '4BKETEUO6'

//export const DEFAULT_K_SKU2 = '4C4AZIVL'
//export const DEFAULT_J_SKU2 = '4LFV5V'


export const DEFAULT_Z_SKU2 = '4BP18I4KV'
export const DEFAULT_KO_SKU2 ='4BSUW3QBL' // '4IQO4RC1' 

export const DEFAULT_Z_QSKU = '20155466'
export const DEFAULT_KJ_QSKU = 'bridal-qsku'
export const DEFAULT_KJ_QSKU2 = 'bridal-set-qsku'

export const DEFAULT_K_URL = 'https://www.kay.com/pjconfigurator/fashion'
export const DEFAULT_J_URL = 'https://www.jared.com/pjconfigurator/fashion'
export const DEFAULT_Z_URL = 'https://www.zales.com/pjconfigurator/fashion'
export const DEFAULT_KO_URL = 'https://www.kayoutlet.com/pjconfigurator/fashion'
export const DEFAULT_PPL_URL = 'https://www.peoplesjewellers.com/pjconfigurator/fashion'
export const DEFAULT_ZO_URL = 'https://www.zalesoutlet.com/pjconfigurator/fashion'

export const INITIAL_ZALES_IMG_URL ='//static.thepersonalizedbest.com/gfr/init_gfr5bw.jpg'
export const INITIAL_KAY_IMG_URL ='//static.thepersonalizedbest.com/gfr/init_gfr5.jpg'
export const INITIAL_KAY_IMG_URL2 ='//static.thepersonalizedbest.com/gfr/init_gfr5.jpg'
export const INITIAL_KAY_IMG_URL61 ='//static.thepersonalizedbest.com/gfr/init_gfr5.jpg'
export const INITIAL_KAY_IMG_URL62 ='//static.thepersonalizedbest.com/gfr/init_gft7.gif'
export const ZALES_SKU_URL ='//test.thepersonalizedbest.com/fashion_zsku2sku6/?zsku='
export const ZALES_SKU_URL_PROD ='//main.thepersonalizedbest.com/fashion_zsku2sku6/?zsku='//'//main.thepersonalizedbest.com/fashion_zsku2sku6/?zsku='

export const START_OVER_STATE = {
  'active_view': 1, cross1: 0, cross2: 0, cross3: 0,
  rs: DEFAULT_STATE_VALUE, rs2: '0', bl2: '0'
}


// WEBPACK FOOTER //
// ./src/constants.js